import React from 'react';

import './TabWidget.css';

class TabWidget extends React.Component {
    constructor(props) {
        super(props);

        this.tabs = props['tabs'];
        this.tabClick = this.tabClick.bind(this);
    }

    tabClick(event) {
        const clicked_tab = event.target.childNodes[0].textContent;
        if (clicked_tab != this.props['selected']) {
            this.props['ontabchange'](clicked_tab);
        }
    }

    render() {
        return (
            <ul id='tabs'>
                {this.tabs.map(t => {
                    return (
                    <li className={t == this.props['selected'] ? 'selected' : ''} key={t.toLowerCase()} onClick={this.tabClick}>
                        {t}
                    </li>);
                })}
            </ul>
        );
    }
}

export default TabWidget;